import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { MarcaProductoInterface } from "../../interfaces/marcaProductosInterfaces/MarcaProducto.interface";

export async function DeleteMarcaProductoAction (
    MarcaId: string
): Promise<ApiResponse<MarcaProductoInterface>> {
   const {data} = await apiClient.delete(`gpMarcaProductos/${MarcaId}`);
    return {
        status: 200,
        data,
        message: "Marca de productos eliminado correctamente",
    };
}
    